import React from 'react';
import {Routes as RouterRoutes, Route, Navigate} from 'react-router-dom';
import {AUTHENTICATED_ENTRY} from 'configs/AppConfig';
import {
    backofficeProtectedRoutes,
    resellerProtectedRoutes,
    advertiserProtectedRoutes,
    customerProtectedRoutes,
    publicRoutes,
    responderProtectedRoutes
} from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const Routes = () => {
    return (
        <RouterRoutes>
            <Route path='/backoffice' element={<ProtectedRoute/>}>
                {backofficeProtectedRoutes.map((route, index) => {
                    return (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>

            <Route path='/reseller' element={<ProtectedRoute/>}>
                {resellerProtectedRoutes.map((route, index) => {
                    return (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>

            <Route path='/responder' element={<ProtectedRoute/>}>
                {responderProtectedRoutes.map((route, index) => {
                    return (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>

            <Route path='/advertiser' element={<ProtectedRoute/>}>
                {advertiserProtectedRoutes.map((route, index) => {
                    return (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>

            <Route path='/customer' element={<ProtectedRoute/>}>
                {customerProtectedRoutes.map((route, index) => {
                    return (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>

            <Route path='/' element={<PublicRoute/>}>
                <Route path='/' element={<Navigate replace to={AUTHENTICATED_ENTRY} />}/>
                {publicRoutes.map((route) => {
                    return (
                        <Route
                            key={route.path}
                            path={route.path}
                            element={
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            }
                        />
                    );
                })}
            </Route>
        </RouterRoutes>
    );
};

export default Routes;
